import {
  getHostName,
  isLocalOrDevEnvironment,
} from "api-helpers/getHostName.ts";

type MetadocLogMeta = Record<string, unknown>;

const getLogContext = () => {
  let host: string | null = null;

  try {
    host = getHostName();
  } catch (error) {
    host = null;
  }

  const appEnv = host?.includes("local.")
    ? "local"
    : host?.includes("dev.")
      ? "dev"
      : "unknown";

  return {
    appEnv,
    host,
  };
};

export const logMetadocDebug = (message: string, meta?: MetadocLogMeta) => {
  if (!isLocalOrDevEnvironment()) {
    return;
  }

  if (meta) {
    // eslint-disable-next-line no-console
    console.log(`[metadoc - dev site only] ${message}`, {
      ...getLogContext(),
      ...meta,
    });
    return;
  }

  // eslint-disable-next-line no-console
  console.log(`[metadoc - dev site only] ${message}`, getLogContext());
};
